// Tenant catalog onboarding remains unavailable until HQ-2 through HQ-4
// replace the legacy canonical-product import flows with tenant-membership-safe
// workflows. This is intentionally code-controlled rather than environment-
// controlled so missing or misconfigured deployment values cannot expose it.
export const TENANT_CATALOG_ONBOARDING_ENABLED = false;

export const TENANT_CATALOG_ONBOARDING_PATHS = Object.freeze([
  "/admin/catalog-import",
  "/admin/catalog-import-csv",
  "/admin/department-mapping",
]);

export const TENANT_CATALOG_ONBOARDING_REDIRECT = "/admin";

export function getTenantCatalogOnboardingRedirect() {
  return TENANT_CATALOG_ONBOARDING_ENABLED
    ? null
    : TENANT_CATALOG_ONBOARDING_REDIRECT;
}

export function isTenantHqNavItemVisible(item, role) {
  return item.available !== false && (!item.roles || item.roles.includes(role));
}
